module.exports = __webpack_public_path__ + "img/ata-logo.643a5f47.png";